<template>
  <a-modal v-model="visible" :title="type === 'modify' ? '修改格子' : '添加格子'" :footer="null">
    <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="格口编号" prop="serial">
        <a-input-number v-model="form.serial" placeholder="格口编号" />
      </a-form-model-item>
      <a-form-model-item label="通道编号" prop="channel" required>
        <a-input-number v-model="form.channel" placeholder="通道编号" />
      </a-form-model-item>
      <a-form-model-item label="规格" prop="type">
        <a-radio-group v-model="form.type">
          <a-radio value="mini">迷你</a-radio>
          <a-radio value="small">小</a-radio>
          <a-radio value="middle">中</a-radio>
          <a-radio value="big">大</a-radio>
          <a-radio value="huge">超大</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="第几组" prop="cabnum">
        <a-select v-model="form.cabnum" placeholder="选择第几组柜子">
          <a-select-option :value="item.value" v-for="item in cabnums" :key="item.value">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-select v-model="form.status" placeholder="选择一个状态">
          <a-select-option :value="item.value" v-for="item in cabinetStatus" :key="item.value">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="是否可用" prop="canuse" v-super>
        <a-switch v-model="form.canuse" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="desc">
        <a-input v-model="form.desc" type="textarea" />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 12, offset: 8 }">
        <a-button type="primary" @click="onSubmit">
          提交
        </a-button>
        <a-button style="margin-left: 10px;" @click="resetForm">
          重置
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import { mapGetters } from 'vuex';
import { stationCabnums } from '@/api/station';
import { createCabinet, modify } from '@/api/cabinet';

const map = {
  大: 'big',
  中: 'middle',
  小: 'small',
  迷你: 'mini',
  超大: 'huge',
};

export default {
  props: ['stationId'],
  data() {
    return {
      visible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      cabnums: [],
      other: '',
      type: 'add',
      form: {
        name: '',
        serial: 0,
        type: 'small',
        channel: 0,
        status: '',
        canuse: true,
        desc: '',
      },
      rules: {
        serial: [
          { required: true, message: '请输入格口编号', trigger: 'blur' },
          { type: 'number', message: '请输入数字', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择一个规格', trigger: 'change' },
        ],
        status: [
          { required: true, message: '请选择一个状态', trigger: 'change' },
        ],
        canuse: [
          { required: true, message: '请选择是否禁用', trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['cabinetStatus']),
  },
  methods: {
    async getStationCabnums() {
      const { stationId } = this;
      const { data } = await stationCabnums(stationId);
      this.cabnums = data;
    },
    show(item) {
      if (item) {
        this.type = 'modify';
        // eslint-disable-next-line no-param-reassign
        item.type = map[item.type];
        this.form = item;
      }
      this.visible = true;
      this.getStationCabnums();
    },
    async submit() {
      let res;
      if (this.type === 'add') {
        const { stationId } = this;
        const { data } = await createCabinet({
          stationId,
          ...this.form,
        });
        res = data;
      } else {
        const { _id } = this.form;
        const { data } = await modify(_id, this.form);
        res = data;
      }
      if (res) {
        this.$message.success('添加成功');
        this.visible = false;
        this.$emit('close');
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          return this.submit();
        }
        console.log('error submit!!');
        return false;
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
